import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { fetchStrech }      from "Actions/Admin/Strech/StrechActions";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";
import StrechStep           from "Utils/Entity/StrechStep";

// Sections
import ScheduleEdit         from "./ScheduleEdit";
import StrechBar            from "Components/Admin/Strech/Strech/StrechBar";

// Components
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchSchedules, deleteSchedule,
} from "Actions/Admin/Strech/ScheduleActions";



/**
 * The Schedule List
 */
class ScheduleList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchSchedules(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        if (this.props.data.canEdit) {
            this.setState({ action, elemID });
        }
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
        this.props.fetchStrech(this.props.elemID);
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        await this.props.deleteSchedule(this.state.elemID);
        this.editElem();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                           } = this.state;
        const { data, strech, params, route, withDetails } = this.props;
        const { canEdit, list, total, sort, loading      } = data;

        const elemName = Utils.getValue(list, "scheduleID", elemID, "name");

        return <Main withDetails={withDetails}>
            <Header message="SCHEDULES_NAME" icon="schedule" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <StrechBar step={StrechStep.SCHEDULES} />
                <Table
                    fetch={this.fetch}
                    sort={sort}
                    none="SCHEDULES_NONE_AVAILABLE"
                    hasAlert={StrechStep.hasHelp(strech, StrechStep.SCHEDULES)}
                >
                    <TableHead>
                        <TableHeader field="weekDay"   message="GENERAL_DAY"               />
                        <TableHeader field="fromHour"  message="SCHEDULES_SINGULAR"        />
                        <TableHeader field="frequency" message="SCHEDULES_FREQUENCY_SHORT" />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.scheduleID} elemID={elem.scheduleID}>
                            <TableCell message={elem.weekDayName}   />
                            <TableCell message={elem.schedule}      />
                            <TableCell message={elem.frequencyName} />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="SCHEDULES_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="SCHEDULES_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <ScheduleEdit
                open={action.isVCE}
                elemID={elemID}
                strechID={params.strechID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="SCHEDULES_DELETE_TITLE"
                message="SCHEDULES_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchStrech    : PropTypes.func.isRequired,
        fetchSchedules : PropTypes.func.isRequired,
        deleteSchedule : PropTypes.func.isRequired,
        data           : PropTypes.object.isRequired,
        strech         : PropTypes.object.isRequired,
        type           : PropTypes.string.isRequired,
        params         : PropTypes.object.isRequired,
        route          : PropTypes.string.isRequired,
        withDetails    : PropTypes.bool.isRequired,
        elemID         : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data   : state.strechSchedule,
            strech : state.strech.elem,
        };
    }
}

export default connect(ScheduleList.mapStateToProps, {
    fetchStrech, fetchSchedules, deleteSchedule,
})(ScheduleList);
